var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"w-full flex flex-col"},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }